import React from 'react';
import {IDetailsColumnRenderTooltipProps} from 'components/FluentUICompat';
import {PropsWithAriaDescribedBy} from '../../../TooltipWithComponentWithAriaDescribedBy';

export type DetailsListHeadingTooltipChildrenProps = Pick<
	IDetailsColumnRenderTooltipProps,
	'children'
> &
	PropsWithAriaDescribedBy;

export function DetailsListHeadingTooltipChildren({
	'aria-describedby': ariaDescribedBy,
	children,
}: DetailsListHeadingTooltipChildrenProps): React.ReactElement {
	return <div aria-describedby={ariaDescribedBy}>{children}</div>;
}
